import { PanelTopClose, PanelTopOpen } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Tip } from "@/components/ui/overlays";
import { useShell } from "@/stores/shell";

/** Show/hide the optional top area.
 *
 *  A TOGGLE, not a one-way "show" button, and deliberately present on both
 *  edges: the top bar has no permanent chrome of its own, so whichever rail is
 *  nearer the pointer should be able to put it away again. Previously only the
 *  left rail could open it and only the bar's own chevron could close it, which
 *  meant crossing the window to undo a click you had just made. */
export function TopBarToggle({ side = "right" }: { side?: "left" | "right" }) {
  const topOpen = useShell((s) => s.topOpen);
  const label = topOpen ? "Hide top bar" : "Show top bar";
  return (
    // The key rides the tooltip so it is learned by using the mouse, and the
    // expanded/controls pairing is what turns "button" into "Top bar,
    // collapsed, button" for a screen reader.
    <Tip label={`${label} — \\`} side={side}>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        onClick={() => useShell.getState().toggleTopBar()}
        aria-label={label}
        aria-expanded={topOpen}
        aria-controls="gv-topbar"
      >
        {topOpen ? <PanelTopClose className="h-4 w-4" /> : <PanelTopOpen className="h-4 w-4" />}
      </Button>
    </Tip>
  );
}
